import { render } from "./ClapSimple.vue?vue&type=template&id=b60fbfc8&scoped=true"
import script from "./ClapSimple.vue?vue&type=script&lang=js"
export * from "./ClapSimple.vue?vue&type=script&lang=js"

import "./ClapSimple.vue?vue&type=style&index=0&id=b60fbfc8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b60fbfc8"]])

export default __exports__